import { css } from "@emotion/css";

const styles = {
    errorDialogOverlay: css`
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-color: rgba(0, 0, 0, 0.5);
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 1000;
        padding: 1rem;
    `,
    errorDialog: css`
        background: white;
        border-radius: 12px;
        padding: 2rem;
        max-width: 80%;
        width: 100%;
        box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1),
            0 10px 10px -5px rgba(0, 0, 0, 0.04);
        text-align: center;
        max-height: 90vh;
        overflow-y: auto;

        @media (min-width: 768px) {
            max-width: 700px;
        }
    `,
    errorDialogHeader: css`
        margin-bottom: 1.5rem;
        h2 {
            color: #6b7280;
            font-size: 1.5rem;
            font-weight: 600;
            margin: 0;
        }
    `,
    errorDialogContent: css`
        p {
            color: #374151;
            margin-bottom: 1.5rem;
            font-size: 1rem;
            line-height: 1.6;
        }
    `,
    errorInfo: css`
        background: #f9fafb;
        border: 1px solid #e5e7eb;
        border-radius: 8px;
        padding: 1rem;
        margin-bottom: 1.5rem;
        text-align: center;

        .error-item {
            margin-bottom: 0.75rem;
            font-size: 1rem;
            color: #374151;
            line-height: 1.5;

            &:last-child {
                margin-bottom: 0;
            }
        }
    `,
    errorDialogActions: css`
        margin-top: 1.5rem;
    `,
    okButton: css`
        background: #3b82f6;
        color: white;
        border: none;
        padding: 0.75rem 2rem;
        border-radius: 8px;
        font-size: 1rem;
        font-weight: 600;
        cursor: pointer;
        transition: background-color 0.2s;

        &:hover {
            background: #2563eb;
        }

        &:focus {
            outline: 2px solid #3b82f6;
            outline-offset: 2px;
        }
    `,
};

export const ErrorDialog = ({ isOpen, onClose, errorData }) => {
    if (!isOpen) return null;

    return (
        <div className={styles.errorDialogOverlay}>
            <div className={styles.errorDialog}>
                <div className={styles.errorDialogHeader}>
                    <h2>Registration Failed</h2>
                </div>
                <div className={styles.errorDialogContent}>
                    <div className={styles.errorInfo}>
                        {errorData.altMsg && (
                            <div className="error-item">{errorData.altMsg}</div>
                        )}
                        <div className="error-item">{errorData.msg}</div>
                    </div>
                    <div className={styles.errorDialogActions}>
                        <button onClick={onClose} className={styles.okButton}>
                            OK
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};
